<template>
  <el-autocomplete
    class="nf-select-list-autocomplete"
    :class="{ active: isFocus }"
    v-model.trim="formData.value"
    :clearable="clearable && isHovering"
    :size="size"
    :fetch-suggestions="querySearchAsync"
    :placeholder="placeholder"
    @select="handleSelect"
    @focus="isFocus = true"
    @blur="handleBlur"
    @clear="handleClear"
    @mouseenter.native="isHovering = true"
    @mouseleave.native="isHovering = false"
  >
    <i
      v-show="!(formData.value && isHovering)"
      class="el-select__caret el-input__icon el-icon-arrow-up"
      :size="size"
      slot="suffix"
    />
  </el-autocomplete>
</template>

<script>
export default {
  name: 'nf-autocomplete',
  props: {
    storeModelName: {
      type: String,
      required: true,
      default: '',
    },
    formData: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: String,
      default: '',
    },
    // 输入框尺寸  默认 small  medium/small/mini
    size: {
      type: String,
      default: 'mini',
    },
    // 是否清空选项 默认false
    clearable: {
      type: Boolean,
      default: false,
    },
    // 占位符
    placeholder: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      restaurants: [],
      state: '',
      timeout: null,
      isFocus: false,
      isHovering: false,
    };
  },
  methods: {
    // 失去焦点
    handleBlur() {
      this.isFocus = false;
      //   this.handleClear();
    },
    // 清空
    handleClear() {
      this.value = '';
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        value: '',
      });
      this.$store.dispatch(`${this.storeModelName}/getList`);
    },
    // 模糊搜索
    async querySearchAsync(queryString, cb) {
      const list = await this.$store.dispatch(this.formData.path, queryString);
      cb(list);
    },
    // 选择
    handleSelect(item) {
      this.value = item.value;
      this.$store.commit(`${this.storeModelName}/updateValueFromIndex`, {
        index: this.index,
        ...item,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.nf-select-list-autocomplete {
  .el-select__caret {
    color: #c0c4cc;
    font-size: 14px;
    transition: transform 0.3s;
    transform: rotateZ(180deg);
    cursor: pointer;
  }
  &.active {
    .el-select__caret {
      transform: rotateZ(0);
    }
  }
}
</style>
